import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom"
import { AnimatePresence } from 'framer-motion';
import {CreateContainer, Header, MainContainer,StoresContainer,DealsContainer, Footer} from "./components"
import { getAllFoodItems } from './utils/firebaseFunctions';
import { useStateValue } from './context/StateProvider';
import { actionType } from "./context/reducer";

const App = () => {
  const [{foodItems}, dispatch ] = useStateValue();
  const fetchData = async () => {
    await getAllFoodItems() .then((data) => {dispatch({
      type: actionType.SET_FOOD_ITEMS,
      foodItems: data,
    });
  });
};
  useEffect(() => { fetchData(); }, []);
  return (
    <AnimatePresence mode='wait'>
    <div className="w-screen h-auto flex flex-col ">
      <Header />
      <main className="mt-14 md:mt-20 px-4 md:px-16 py-4 w-full">
        <Routes>
          <Route path="/*" element={<MainContainer />} />
          <Route path="/createItem" element={<CreateContainer />} />
          <Route path="/stores" element={<StoresContainer />} />
          <Route path="/deals" element={<DealsContainer />} />
          </Routes>   
      </main>
    </div>
    <Footer/>
    </AnimatePresence>
    
  )
}
export default App